import './GoogleTripadvisor.scss';

import { Icon, isDefaultBrand, useConfig } from '@travelwin/core';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Align } from '../RatingWidget';

const TRIPADVISOR_ICON = 'tripadvisorRatingIcon';
const GOOGLE_ICON = 'googleRatingIcon';
const TRIPADVISOR_RATING_URL =
  'https://www.tripadvisor.co.uk/Attraction_Review-g186338-d24151194-Reviews-Sim_Local-London_England.html';

const className = 'c-GoogleTripadvisor';

export const GoogleTripadvisor = ({ align }: { align: Align }) => {
  const { t } = useTranslation();
  const { WHITELABEL_BRAND } = useConfig();
  const activateLinks = isDefaultBrand(WHITELABEL_BRAND);

  return (
    <div className={classNames(className, `${className}--${align}`)}>
      {activateLinks ? (
        <a
          aria-label={t('trusted_by.tripadvisor', 'TripAdvisor')}
          href={TRIPADVISOR_RATING_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name={TRIPADVISOR_ICON} />
        </a>
      ) : (
        <Icon name={TRIPADVISOR_ICON} />
      )}
      <Icon name={GOOGLE_ICON} />
    </div>
  );
};

export default GoogleTripadvisor;
